import { NoBlending, ShaderMaterial, Uniform } from 'three'

import fragmentShader from "./glsl/FilmGrain.frag";
import vertexShader from "./glsl/FilmGrain.vert";

/**
 * A simple copy shader material.
 */

export class FilmGrainMaterial extends ShaderMaterial {

    constructor() {
        super({
            name: "FilmGrainMaterial",
            uniforms: {
                inputBuffer: new Uniform(null),
                intensity: new Uniform(0.025),
                noiseOffset: new Uniform(0.0),
            },
            blending: NoBlending,
            depthWrite: false,
            depthTest: false,
            fragmentShader,
            vertexShader
        });
    }


    /**
     * The input buffer.
     *
     * @type {Texture}
     */

    set inputBuffer(value) {

        this.uniforms.inputBuffer.value = value;

    }

    /**
     * Sets the input buffer.
     *
     * @deprecated Use inputBuffer instead.
     * @param {Number} value - The buffer.
     */

    setInputBuffer(value) {

        this.uniforms.inputBuffer.value = value;

    }

    /**
     * Returns the opacity.
     *
     * @deprecated Use opacity instead.
     * @return {Number} The opacity.
     */

    getOpacity(value) {

        return this.uniforms.opacity.value;

    }

    /**
     * Sets the opacity.
     *
     * @deprecated Use opacity instead.
     * @param {Number} value - The opacity.
     */

    setOpacity(value) {

        this.uniforms.opacity.value = value;

    }

}
